import React from 'react'
import { Link } from 'gatsby'
import { BloomLink } from '../General'

import { useStore } from '../../lib/context'
import { observer } from 'mobx-react-lite'
import { motion } from 'framer-motion'
import css from 'styled-jsx/css'

const { className, styles } = css.resolve`
	div {
		font-family: 'Elizeth';
		font-weight: 500;
		text-transform: uppercase;
		padding: 0 2.5rem;
		font-size: var(--font--xs);
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		-webkit-backface-visibility: hidden;
		-webkit-transform: translate3D(0, 0, 0);
	}

	@media only screen and (max-width: 768px) {
		div {
			padding: 0 1.5rem;
		}
	}
`

const NavLink = observer(({ animated, label, link, noPadding }) => {
	const {
		uiStore: { navBar__textColor },
	} = useStore()
	const animate = { color: navBar__textColor }
	const transition = { delay: animated ? 0.5 : 0, duration: animated ? 0.8 : 0 }
	return (
		<>
			<Link to={link} state={{ prevName: link }}>
				<motion.div
					style={{
						padding: noPadding ? 0 : '0 2.5rem',
					}}
					animate={animate}
					transition={transition}
					className={className}
				>
					{label}
				</motion.div>
			</Link>

			{styles}
		</>
	)
})

export default NavLink
